import React, { useState,useEffect } from 'react';
import ListLayout from '../../../components/common/List/List-Layout';
import { useNavigate } from 'react-router-dom';
import { useGetFoodItemListQuery ,useDeleteFoodItemMutation} from '../../../store/api/meals';
import ConfirmationModal from '../../../components/common/List/DeletePopup';

function Fooditem() {
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);
    const [deleteId, setDeleteId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const permissionname = 'fooditem';
    const [DeleteFood]= useDeleteFoodItemMutation()

    const { data: tabledata, refetch, isLoading } = useGetFoodItemListQuery({
        page: currentPage,
        page_size: pageSize,
    });

    const actionButtons = [
        {
            icon: "MdOutlineModeEdit",
            onClick: (row) => {
                navigate("/edit-mealitem", { state: { data: row,pageName: "Food Item" } });  
            },
        },
        {
            icon: "RiDeleteBinLine",
            onClick: (row) => {
                setDeleteId(row);
                setIsModalOpen(true);
            },
        },
    ];

    const handleDelete = async () => {
        try {
            await DeleteFood(deleteId.id);
            setIsModalOpen(false);
            refetch()
          } catch (error) {
           
            refetch();
          }
    };

    const tableHeaders = [
        { label: "S.NO", key: "serial_no", increameant: true, placeholder: "S.NO" },
        { label: "Fooditem", key: "name" },
        { label: "Calories", key: "calories" },
        { label: "Protein", key: "protein" },
        { label: "Carbs", key: "carbs" },
        { label: "Fats", key: "fats" },
    ];

    const Buttons = [
        {
            title: "+ Add FoodItem",
            design: "px-2 text-base py-1.5 bg-secondary font-normal text-white rounded hover:bg-secondary-700 flex items-center gap-1",
            onClick: () => navigate("/create-mealitem", { state: { pageName: "Food Item" } }),
        },
    ];

     useEffect(()=>{
        refetch();
      },[])

    return (
        <div>
            <ListLayout
                title="FoodItem List"
                Buttons={Buttons}
                permissionname={permissionname}
                tabledata={tabledata?.data || []} 
                tableHeaders={tableHeaders}
                actionButtons={actionButtons}
                currentPage={currentPage}
                totalrecords={tabledata?.count || 0} 
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                isLoading={isLoading}
            />

            {isModalOpen && (
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onConfirm={handleDelete}
                />
            )}
        </div>
    );
}

export default Fooditem;